import { ContaParcela } from "./conta-parcela.model";

export class Conta {

  contaId: number = 0;

  tpConta: number = 0;

  dataCompetencia: Date = new Date();

  tipoAdiantamento: number = 0;

  //Se tpConta for 0 então é cliente
  //se tpConta for 1 então é fornecedor
  //se tpConta for 2 pode ser Cliente, Fornecedor ou Funcionário dependentedo do tipoAdiantamento
  parceiroId: number = 0;

  descricaoConta: string = '';

  nomeParceiro: string = '';

  dataCriacao: Date = new Date();

  grupoContaId: number = 0;

  empresaId: number = 0;

  saldo: number = 0;

  valor: number = 0;

  nfeId: number = 0;

  gerarNFSeAutomaticamente: boolean = false;

  saguiClienteId: number = 0;

  caixaId: number = 0;

  contaContabilDebitoId: number = 0;

  contaContabilCreditoId: number = 0;

  centroCustoId: number = 0;

  contaParcelas: ContaParcela[] = [];

  comportamentoNfse: number = 0;

  documentoFiscal: number = 0;

  funcionarioId: number | null = 0;

  fornecedorId: number | null = null;

  clienteId: number | null = null;

  nfseId: number | null = null;

  valorTotal: number = 0;

  valorDesconto: number = 0;

  valorBruto: number = 0;

  valorLiquido: number = 0;

  valorAposRetencoes: number = 0;

  faturaId: number | null = null;

  contaStatusFiscal: StatusNotaFiscal = StatusNotaFiscal.Pendente;

}


  export enum TipoConta
  {
      ContaAReceber,
      ContaAPagar,
      Adiantamento
  }

  export enum StatusNotaFiscal{
    Pendente,
    Gerada,
    Falha,
    Cancelada,
  }

  
